import './AdSlot.css';

const AdSlot = ({ label = 'Ad space reserved', variant = 'banner' }) => {
  return (
    <aside className={`ad-slot ad-slot-${variant}`} aria-label={label}>
      <span>{label}</span>
    </aside>
  );
};

export default AdSlot;
